import DealerRewardListPanel from "./dealerRewardListPanel.container"

export default DealerRewardListPanel
